import React, { useEffect, useState } from "react";

import PaymentSection from "./../../components/checkout/payment_section/PaymentSection";
import "./Doctor_Payment.css";
import Green_btn from "../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../common-components/common_modal/success_modal/Success_Modal";
import {
  checkDoctorBooking,
  createDoctorAppointment,
  getDoctor,
} from "../../features/doctor/doctorSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  decodeId,
  formatTime,
  PayementMethodIds,
  RolesIds,
} from "../../utils/common";
import Loader from "../common-components/Loader/Loader";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import Login_Modal from "../common-components/common_modal/login_modal/Login_Modal";
import Set_New_Password_Modal from "../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Reset_Password_Modal from "../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import useRazorpay from "react-razorpay";
import Delete_Modal from "../common-components/common_modal/delete_modal/Delete_Modal";
import { useNavigate } from "react-router-dom";

function Doctor_Payment() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      payment_method: "",
      report: null,
    },
  });
  const navigate = useNavigate();
  const isSignin = useSelector((state) => state.auth.is_signin);

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [showError, setShowError] = useState(false);
  const [successText, setSuccessText] = useState(false);

  const formData = new FormData();
  const [modalShow, setModalShow] = React.useState(false);
  const [loading, setLoading] = useState(true);

  const appointment = JSON.parse(localStorage.getItem("appointmentDetails"));
  const dispatch = useDispatch();

  const doctor = useSelector((state) => state.doctor.doctor);

  const fetchDoctor = async () => {
    try {
      setLoading(true);

      await dispatch(getDoctor(decodeId(appointment?.doctor_id)));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (appointment?.doctor_id) {
      fetchDoctor();
    } else {
      setLoading(false);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    }
  }, [dispatch, appointment?.doctor_id]);

  const onBookAppointment = async (data) => {
    if (!isSignin) {
      setShowLoginModal(true);
      return;
    }

    formData.append("doctor_id", doctor?.id);
    formData.append("appointment_date", appointment.appointment_date);
    formData.append("slot_time", appointment.slot_time);
    formData.append("session_id", decodeId(appointment.session_id));
    formData.append("payment_method_id", data.payment_method);
    formData.append("fees", doctor?.Doctor_Detail?.fees);

    if (data?.report?.length) {
      formData.append("report", data.report[0]);
    }

    try {
      const response = await dispatch(checkDoctorBooking(formData));

      if (response?.meta?.requestStatus === "fulfilled") {
        if (Number(data.payment_method) === PayementMethodIds.Online) {
          await handleRazorpay(doctor?.Doctor_Detail?.fees);
        } else {
          await bookAppointment();
        }
      } else if (response?.meta?.requestStatus === "rejected") {
        setSuccessText(response.payload.errors);
        setShowError(true);

        setTimeout(() => {
          setShowError(false);
          setSuccessText("");
        }, 3000);
      }
    } catch (err) {
      console.log(err);
      setSuccessText(err.message);
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
        setSuccessText("");
      }, 3000);
    }
  };

  const bookAppointment = async (payment_id) => {
    // const formData = new FormData();

    // formData.append("doctor_id", doctor.id);
    // formData.append("appointment_date", appointment.appointment_date);
    // formData.append("session_id", decodeId(appointment.session_id));
    // formData.append("consultation_type", "ONLINE");
    // formData.append("payment_method_id", data.payment_method);
    // formData.append("remarks", "");

    if (payment_id) {
      formData.append("payment_id", payment_id);
    }

    const response = await dispatch(createDoctorAppointment(formData));

    if (response?.meta?.requestStatus === "fulfilled") {
      setModalShow(true);
      setSuccessText(response.payload.data);
      localStorage.removeItem("appointmentDetails");

      setTimeout(() => {
        navigate("/");
        setModalShow(false);
        setSuccessText("");
      }, 3000);
    } else if (response?.meta?.requestStatus === "rejected") {
      setSuccessText(response.payload.errors);
      setShowError(true);

      setTimeout(() => {
        setShowError(false);
        setSuccessText("");
      }, 3000);
    }

    // if (response.meta.requestStatus === "fulfilled") {
    //   setModalShow(true);
    // }
  };

  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      // key: "rzp_test_I05KCFb1v5JJRc",
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "RED LOTTUS",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        // await setRazorId(res.razorpay_payment_id);
        await bookAppointment(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  if (loading) {
    return <Loader color={"#97ac2f"} />;
  }

  return (
    <section className="process-checkout-section doctor-payment-section">
      <div className="container">
        <div className="row custom_doctor_row">
          <div className=" cart-top col-12 col-lg-7 left-col">
            <PaymentSection
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            />
          </div>
          <div className="col-12 col-lg-5">
            <div className="doctor-info-card">
              <div className="doctor-top">
                <div className="doctor-image">
                  {/* <img src="/assets/images/home/dr/img1.png" alt="doctor" /> */}
                  <img
                    src={process.env.REACT_APP_IMG_URL + doctor?.image}
                    alt={doctor?.name || "doctor"}
                  />
                </div>

                <div className="doctor-content">
                  <h3 className="dr-name">
                    {doctor?.Doctor_Detail?.doctor_code || ""}.{" "}
                    {doctor?.name || ""}
                  </h3>

                  <p className="specialist">
                    {doctor?.Doctor_Detail?.Specialization?.name || ""} ({" "}
                    {doctor?.Doctor_Detail?.degree || ""})
                  </p>
                  <div className="date-wrapper">
                    <p className="info-text">
                      <span className="headingg"> Date:-</span>{" "}
                      <span className="value">
                        {" "}
                        {dayjs(appointment?.appointment_date).format(
                          "DD MMM YYYY",
                        )}
                      </span>
                    </p>

                    <p className="info-text">
                      <span className="headingg"> Timing:- </span>{" "}
                      <span className="value">
                        {formatTime(appointment?.slot_time)}
                      </span>
                    </p>
                    <p className="info-text">
                      <span className="headingg"> Fees:- </span>{" "}
                      <span className="value">
                        ₹ {doctor?.Doctor_Detail?.fees || "0"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="btn-wrapper">
                {/* <Green_btn
                  btnText="Book Now"
                  onClick={() => setModalShow(true)}
                /> */}

                <Green_btn
                  btnText="Book Now"
                  onClick={handleSubmit(onBookAppointment)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText={successText}
      />

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
        setShowLogin={() => setShowLogin(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successful!"
      />

      <Success_Modal
        show={showLogin}
        onHide={() => {
          setShowLogin(false);
        }}
        successText="Login Successfully!"
      />

      <Delete_Modal
        show={showError}
        onHide={() => {
          setShowError(false);
        }}
        successText={successText}
      />
    </section>
  );
}

export default Doctor_Payment;
